import React from 'react';
import styles from './PubImageHeaderLongHop.module.css';
import { Link } from 'react-router-dom';
import Indicator from '../Indicator/Indicator';

const PubImageHeaderLongHop = (props) => {
  const {pubLogo, sectionImg,pubLinkLabel,pubLink,step ,stepLength = 4, imagePosition } = props;
  return (
    <div className={styles.pubImgMain}>
      {
        pubLogo && <img src={pubLogo} alt="logo" className={styles.publogo} />
      }
      {
        sectionImg && <img src={sectionImg} alt="section_" className={`${styles.pubImg} ${imagePosition === "center" ? styles.center : imagePosition === "left" ? styles.left : styles.right}`} />
      }
      
      {/* Indicator */}
      {
        step && <Indicator step={step} stepLength={stepLength} />
      }

      {
        pubLink && <Link to={pubLink} className='chose__another__link'>
        {pubLinkLabel}
      </Link>
      }

    </div>
  );
};

export default PubImageHeaderLongHop;